export function fechaLegible(fecha) {
  if (!fecha) return "Fecha por confirmar";
  return new Intl.DateTimeFormat("es-CO", { day: "2-digit", month: "2-digit", year: "numeric" }).format(new Date(fecha));
}

export function horaLegible(fecha) {
  if (!fecha) return "Hora por confirmar";
  return new Intl.DateTimeFormat("es-CO", { hour: "numeric", minute: "2-digit" }).format(new Date(fecha));
}

export function numeroContacto(urlWhatsapp) {
  if (!urlWhatsapp) return "";
  try {
    return new URL(urlWhatsapp).pathname.replace(/\D/g, "");
  } catch {
    return "";
  }
}
